import React from "react";

import { HtmlProcessorExtensionProvider } from "../../../../../../plugins/@whitespace/gatsby-theme-wordpress-basic/src/components";

import WpModularityModule from "./WPModularityModule.jsx";

const modularityShortcode = {
  inputTransforms: [],
  treeTransforms: [],
  stringifierComponents: {
    modularity: WpModularityModule,
  },
};

export default function RootElementWrapper({ children }) {
  return (
    <HtmlProcessorExtensionProvider {...modularityShortcode}>
      {children}
    </HtmlProcessorExtensionProvider>
  );
}
